import TypeUtils from '@/helpers/type-utils';
import {AvailablePeriodType} from '@/data/models/enums/available-period-type';

export default class StatsConsumptionForm {
  startDate: Date;
  period: AvailablePeriodType;
  metersIds: string[];
  buildingId: string;
  dl: boolean;

  static map(data: Partial<StatsConsumptionForm>): StatsConsumptionForm {
    if (!data) {
      return null;
    }

    const statsForm: StatsConsumptionForm = new StatsConsumptionForm();

    statsForm.startDate = TypeUtils.hasDateOrDefault(data.startDate);
    statsForm.period = TypeUtils.hasEnumOrDefault(data.period, AvailablePeriodType);
    statsForm.metersIds = TypeUtils.hasArrayOrDefault(data.metersIds, []);
    statsForm.buildingId = TypeUtils.hasStringOrDefault(data.buildingId, "");
    statsForm.dl = TypeUtils.hasBooleanOrDefault(data.dl, false);

    return statsForm;
  }

  toJSON(): Partial<StatsConsumptionForm> {
    return {
      'startDate': this.startDate,
      'period': this.period,
      'metersIds': this.metersIds,
      'buildingId': this.buildingId || null,
      'dl': this.dl || false
    };
  }
}
